const prefix = process.env.VUE_APP_API_URL + 'vocabulary/'

export const getRulesAPI = prefix + 'get-practice-rules'
export const getGlossariesAPI = prefix + 'glossaries'
export const getBooksByGlossaryAPI = prefix + 'get-books-by-glossary'
export const getLessonsByBookAPI = prefix + 'get-lessons-by-book'
export const getInitialSequenceAndBlockSizeAPI = prefix + 'get-initial-sequence-and-block-size'
export const getWordsAPI = prefix + 'get-words'

export const createCompleteRecordAPI = prefix + 'create-complete-record'
export const createSubrecordAPI = prefix + 'create-sub-record'

export const getExamsAPI = prefix + 'exams'
export const getExamAPI = prefix + 'exam'
export const getExamWordsAPI = prefix + 'get-exam-words'
export const createExamCompleteRecordAPI = prefix + 'create-exam-complete-record'
export const createExamSubrecordAPI = prefix + 'complete-exam-record'

export const getVocabularyLearnNewOrReviewHistoryAPI = prefix + 'get-vocabulary-learn-new-or-review-history'
export const getVocabularyExamHistoryAPI = prefix + 'get-vocabulary-exam-history'

export const checkIfForceReviewAPI = prefix + 'check-if-force-review'

export const getAllCertsAPI = prefix + 'getAllCerts'
export const downloadCertAPI = prefix + 'downloadCert'
